import React from 'react';
import { color, radius } from '../tokens';

interface FieldProps {
  label?: string;
  hint?: string;
  children: React.ReactNode;
  htmlFor?: string;
}

const wrap: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 14 };
const labelStyle: React.CSSProperties = { fontSize: 14, fontWeight: 600, color: color.text };
const hintStyle: React.CSSProperties = { fontSize: 13, color: color.textMuted };

/** Labelled field wrapper for consistent spacing and help text. */
export function Field({ label, hint, children, htmlFor }: FieldProps) {
  return (
    <div style={wrap}>
      {label ? <label htmlFor={htmlFor} style={labelStyle}>{label}</label> : null}
      {children}
      {hint ? <div style={hintStyle}>{hint}</div> : null}
    </div>
  );
}

const controlBase: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  minHeight: 44,
  padding: '11px 14px',
  borderRadius: radius.md,
  background: color.surfaceRaised,
  border: `1px solid ${color.border}`,
  color: color.text,
  fontSize: 15,
  outline: 'none',
};

export const TextInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function TextInput({ style, ...rest }, ref) {
    const s: React.CSSProperties = { ...controlBase, ...style };
    return <input ref={ref} style={s} {...rest} />;
  },
);

export const TextArea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function TextArea({ style, ...rest }, ref) {
    const s: React.CSSProperties = { ...controlBase, minHeight: 96, resize: 'vertical', ...style };
    return <textarea ref={ref} style={s} {...rest} />;
  },
);

export default Field;
